// removed by extract-text-webpack-plugin
module.exports = {"sms":"JdDuH"};


//////////////////
// WEBPACK FOOTER
// ./src/components/SocialShare/SmsShare.scss
// module id = ./src/components/SocialShare/SmsShare.scss
// module chunks = 5